import { useSearchWidget } from '@/hooks/useSearchWidget';

/**
 * Search-derived context for GTM ecommerce events (BR-57983): flat passenger
 * count and round-trip flag. Returns zero passengers when no search has been
 * submitted in this session (e.g. deep-linked flows) — callers should omit
 * the parameter in that case, per the tagging plan's missing-value rule.
 */
export const useGTMSearchContext = () => {
  const { currentSearchFormValues } = useSearchWidget();

  return {
    totalPassengers: currentSearchFormValues?.passengers.length ?? 0,
    roundTrip: Boolean(currentSearchFormValues?.returnDate),
  };
};
